import gql from 'graphql-tag';

export const deleteMatchMutation = gql`
	mutation DeleteMatch($id: ID!) {
		deleteMatch(id: $id) {
			id
		}
	}
`;
